module.exports = __webpack_public_path__ + "img/logo_greenlv.67433a9c.jpg";